import { graphql, useStaticQuery } from 'gatsby';

export const useFooter = () => {
  const footer = useStaticQuery(graphql`
    query {
      contentfulFooter(title: { eq: "Footer" }) {
        emailPlaceholder
        emailTitle
        learnMore {
          title
          url
        }
        pageLinks {
          title
          url
        }
        socialMediaLinks {
          title
          url
          icon {
            ...ContentfulSvgImageFragment
          }
        }
        copyright
      }
    }
  `);

  return footer.contentfulFooter;
};
